import { TopicResponse, TranslationObject } from "../types";
import { capitalizeFirst } from "./util";

const getAlternativeLanguages = (translations: TranslationObject) => {
    const altLngs = translations ? Object.keys(translations) : [];
    return altLngs;
};

export const getGreetingMessages = (topicData: TopicResponse | null, currentLanguage: string) => {
    if(!topicData) return [];

    let greetingMessages = topicData.greeting.messages ?? [];

    const altLngs = topicData.translations ? Object.keys(topicData.translations) : [];
    const usingDefaultLanguage = currentLanguage === topicData.topic.defaultLanguage;

    if(!usingDefaultLanguage && altLngs.includes(currentLanguage)) {
        const greetingsTranslation = topicData?.translations[currentLanguage].greetings;
        const greetingKeys = Object.keys(greetingsTranslation ?? {});

        greetingMessages = greetingKeys.map((key: string) => greetingsTranslation?.[key]?.text ?? '');
    }

    return greetingMessages;
};

export const getInitQuestion = (topicData: TopicResponse | null, currentLanguage: string) => {
    if(!topicData) return '';

    const altLngs = topicData.translations ? Object.keys(topicData.translations) : [];
    const usingDefaultLanguage = currentLanguage === topicData.topic.defaultLanguage;

    if(!usingDefaultLanguage && altLngs.includes(currentLanguage)) {
        return topicData.translations[currentLanguage].initQuestion;
    } else if(topicData.initQuestion && topicData.initQuestion.initialQuestion.length > 0) {
        return topicData.initQuestion.initialQuestion;
    } else {
        return capitalizeFirst(topicData.topic.name);
    }
};

const stripZeroWidthSpaces = (str: string | undefined): string => {
    if(!str) return '';
    return str.replace(/\u200B/g, '');
};

export const getQuestionText = (
    topicData: TopicResponse | null,
    questionId: number,
    currentLanguage: string
) => {
    if(!topicData) return '';

    const question = topicData.qna.questions.find(q => q.questionId === questionId);
    if(!question) return '';

    let questionTitle = question?.questionText;

    const altLngs = getAlternativeLanguages(topicData.translations);
    const usingDefaultLanguage = currentLanguage === topicData?.topic.defaultLanguage;

    if(!usingDefaultLanguage && altLngs.includes(currentLanguage)) {
        const qnaTranslation = topicData?.translations[currentLanguage].qna;
        return qnaTranslation?.[question.oldQuestionId ?? 0]?.text ?? '';
    }

    return stripZeroWidthSpaces(questionTitle);
}

export const getAnswerText = (
    topicData: TopicResponse | null,
    questionId: number,
    answerId: number,
    currentLanguage: string
) => {
    if(!topicData) return '';

    const question = topicData.qna.questions.find(q => q.questionId === questionId);
    const answer = question?.answers?.find(a => a.answerId === answerId);

    if(!question || !answer) return '';

    let answerText = answer.answerText;      

    const altLanguages = getAlternativeLanguages(topicData.translations);
    const usingDefaultLanguage = currentLanguage === topicData.topic.defaultLanguage;

    if(!usingDefaultLanguage && altLanguages.includes(currentLanguage)) {
        const qnaTranslation = topicData.translations[currentLanguage].qna;
        return qnaTranslation?.[question.oldQuestionId ?? 0]?.answers?.[answer.answerId]?.text ?? '';
    }

    return answerText;
};